import { MimeType } from '@/constants/constants-mime-types'

export enum AgencyOriginalFormat {
  PDF = 'pdf',
  PLAIN_TEXT = 'plain_text',
  MARKDOWN = 'markdown',
}

/** The saved original formats the agency viewer renders and offers for download; null for every other format. */
export function getAgencyOriginalFormat(mediaType: string | null | undefined): AgencyOriginalFormat | null {
  switch (mediaType) {
    case MimeType.PDF:
      return AgencyOriginalFormat.PDF
    case MimeType.PLAIN_TEXT:
      return AgencyOriginalFormat.PLAIN_TEXT
    case MimeType.MARKDOWN:
      return AgencyOriginalFormat.MARKDOWN
    default:
      return null
  }
}
